export default __webpack_public_path__ + "static/media/ico_change.8aacdd37.svg";